import { useState } from 'react';

export default function useSidebar() {
  const [activePanel, setActivePanel] = useState<'Conflicten' | 'Defecten' | 'Signalen' | 'Mwd' | undefined>();

  return {
    activePanel,
    setActivePanel,
  };
}
